import * as React from 'react';
import ReactDOM from 'react-dom';

import { map } from 'lodash';

import createLoadableComponent from 'js/lib/createLoadableComponent';

import { isSupportedAudioExtension } from 'bundles/cml/legacy/utils/AssetUtils';

const AudioPlayer = createLoadableComponent(() => import('bundles/cml/legacy/components/AudioPlayer'));

type Props = {
  children: JSX.Element;
};

/**
 * Wrapper that replaces all child audio asset nodes with an interactive audio player via videoJS
 * */
class CMLAudioJS extends React.Component<Props> {
  _isMounted = false;

  componentDidMount() {
    this._isMounted = true;

    // eslint-disable-next-line react/no-find-dom-node
    const dom = ReactDOM.findDOMNode(this);

    if (!dom || !(dom instanceof Element)) {
      return;
    }

    const audio = Array.from(dom.querySelectorAll<HTMLElement>('.cml-asset-audio'));

    map(audio, (assetEl) => {
      const src = assetEl.getAttribute('data-url');
      const extension = assetEl.getAttribute('data-extension');

      if (src && extension && isSupportedAudioExtension(extension)) {
        // retain ariaLabel so it can be added back after the DOM is replaced
        const ariaLabel = assetEl.firstElementChild?.getAttribute('aria-label') ?? undefined;

        // eslint-disable-next-line
        assetEl.innerHTML = '';

        ReactDOM.render(
          <AudioPlayer audioUrl={src} aria-label={ariaLabel} audioType={`audio/${extension}`} />,
          assetEl
        );
      }
    });
  }

  shouldComponentUpdate() {
    return false;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return <div>{this.props.children}</div>;
  }
}

export default CMLAudioJS;
